import React from "react";
import { Route, Routes } from "react-router-dom";
import IndexProfessionalAttributes from "./settings/professionalAttributes/IndexProfessionalAttributes";
import IndexEvaluationScales from "./settings/evaluationScale/IndexEvaluationScale";
import IndexProbations from "./probationers/probation/IndexProbation";
import IndexEvaluations from "./probationers/evaluation/IndexEvaluations";
import { guardElement } from "@comps/components";

const AssessmentModules = () => {
  return (
    <Routes>
      <Route path="settings/professional-attributes" element={ guardElement(<IndexProfessionalAttributes modkey="professionalAttributesProbation"/>, "professionalAttributesProbation") } />
      <Route path="settings/evaluation-scales" element={ guardElement(<IndexEvaluationScales modkey="evaluationScales"/>, "evaluationScales") } />
      <Route path="probations/requests" element={ guardElement(<IndexProbations modkey="probationRequests"/>, "probationRequests") } />
      <Route path="probations/approvals" element={ guardElement(<IndexEvaluations modkey="probationApprovals"/>, "probationApprovals") } />
    </Routes>
  );
}

export default AssessmentModules;
